var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c_table_wrap"},[_vm._v(" 공지사항 리스트 레이아웃 "),_c('div',[_c('button',{on:{"click":function($event){return _vm.goDetail(_vm.idx)}}},[_vm._v("상세")])]),_c('div',[_c('button',{on:{"click":function($event){return _vm.$router.push('/notice/create')}}},[_vm._v("등록")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }